export class RelatedGlobalDbCluster {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RelatedGlobalDbCluster.attributeTypeMap;
    }
    constructor() {
    }
}
